// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5878) return "static/chunks/5878-ffdc7c65f1ac2bd5.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9910 ? "a4634e51" : chunkId) + "." + {"301":"31a4ee60f5dc8a99","393":"0bc68b75196a299c","1257":"50c169a728538d07","3623":"afdf173e65688c5f","4046":"543728ab6f326e50","4543":"37e81df5ebbc7fbb","6483":"d0838765279e42d7","8768":"3f85c9976d28bd86","9910":"1f11e9a81dca31fe"}[chunkId] + ".js";
};